$(document).ready(function() {                  
    $('.header__icon_wrapper span.cls').click(function() {
      $('summary.header__icon.header__icon--menu.header__icon--summary.link').click();
    })

    $('h2.mobile-facets__heading.medium-hide.large-up-hide').click(function() {
      $('.mobile-facets__open-wrapper').click();
    })
  
    $('.arne-color-swatch-element').hover(function(){
      var t = $(this).attr('rel_title');
      var p = $(this).attr('rel_price');
      $('.arne-color-swatch-element').removeClass('active');
      $(this).addClass("active");
      $('span.h').html(t);
      $('span.p').html(p);
    })
    var cartUpsellSwiper = new Swiper(".mySwiper_Cart_Upsell", {
      slidesPerView: 1.5,
      pagination: {
        el: ".swiper-pagination",
      },
    });
  
    var thumbs = new Swiper(".swiper_thumb_banner", {
      slidesPerView: 3,
      spaceBetween: 10,
      centeredSlides: true,
         centeredSlidesBounds: true,
      allowTouchMove: false,
      loop: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        },
      },
    });

  thumbs.slides.forEach(slide => {
  slide.onclick = () => {
    slider.slideToLoop(slide.dataset.swiperSlideIndex);
  }
})
  
    var slider = new Swiper(".swiper_main_banner", {
      slidesPerView: 3,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: true,
      spaceBetween: 0,
      breakpoints: {
        0: {
          slidesPerView: 1,
          allowTouchMove: false,
        },
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        },
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
    });  
  
    slider.controller.control = thumbs;
    thumbs.controller.control = slider;
    // $('button.open_close_filter').trigger('click');
    $('.images-banner-slider-in .swiper-button-next').trigger('click');

})
$(document).on('click', 'button.open_close_filter', function() {
    var t = $(this).find('span').text();
    if (t == 'Open Filters') {
      $(this).find('span').html('Close Filters');
    } else {
      $(this).find('span').html('Open Filters');
    }
    $('aside#main-collection-filters').toggle();
});

$(document).on('click', '.template-product.pro-drawer-pushtoleft .overlaydrawer', function() {
    $('body').removeClass('pro-drawer-pushtoleft');
    $drawerRight.removeClass('pro-drawer-open');
});

$(document).ready(function() {
	$drawerRight = $('.pro-drawer-right');
	$cart_list = $('.pro-drawer-btn, .pro-drawer-close-btn');
		
	$cart_list.click(function() {
        var atrtab = $(this).attr('tab');
      
		$(this).toggleClass('active');
		$('body').toggleClass('pro-drawer-pushtoleft');
		$drawerRight.toggleClass('pro-drawer-open');

        if (atrtab) {
          $('.ele_accordion__title[tab="'+atrtab+'"]').click();
        }
	});
	
	//BEGIN
	$(".ele_accordion__title").on("click", function(e) {

		e.preventDefault();
		var $this = $(this);

		if (!$this.hasClass("accordion-active")) {
			$(".accordion__content").slideUp(400);
			$(".ele_accordion__title").removeClass("accordion-active");
			$('.accordion__arrow').removeClass('accordion__rotate');
		}

		$this.toggleClass("accordion-active");
		$this.next().slideToggle();
		$('.accordion__arrow',this).toggleClass('accordion__rotate');
	});
	//END
	
});

